
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/data/h1b-lottery-simulator",
      function () {
        return require("private-next-pages/data/h1b-lottery-simulator.tsx");
      }
    ]);
  